module.exports = __webpack_public_path__ + "img/icon_drapdown.15fb21d4.svg";